import { render, staticRenderFns } from "./MaterialPage.vue?vue&type=template&id=83f4021c&scoped=true&"
import script from "./MaterialPage.vue?vue&type=script&lang=js&"
export * from "./MaterialPage.vue?vue&type=script&lang=js&"
import style0 from "./MaterialPage.vue?vue&type=style&index=0&id=83f4021c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f4021c",
  null
  
)

export default component.exports